/** Ausente equivale a 'MESSAGE': documentos e clientes anteriores ao alerta seguem funcionando. */
export type UnreadNotificationKind = 'MESSAGE' | 'SPEND_LIMIT_ALERT'

export const isMessageNotification = (notification: { kind?: UnreadNotificationKind }): boolean =>
    !notification.kind || notification.kind === 'MESSAGE'
